import LegalLayout from './LegalLayout'
import DocumentMeta from './DocumentMeta.jsx'

const LAST_UPDATED = '19 Φεβρουαρίου 2026'

function Cookies() {
  return (
    <>
      <DocumentMeta
        title="Πολιτική Cookies | Πανελλήνιες+"
        description="Πληροφορίες για τα cookies, τις κατηγορίες τους και τη διαχείριση συγκατάθεσης στο Πανελλήνιες+."
        canonical="https://www.panellhniesplus.gr/cookies"
        robots="noindex, follow"
      />

      <LegalLayout title="Πολιτική Cookies">
        <p>
          Τελευταία ενημέρωση: <strong>{LAST_UPDATED}</strong>
        </p>
        <p>
          Τα cookies είναι μικρά αρχεία που αποθηκεύονται στη συσκευή σας και βοηθούν στη λειτουργία,
          μέτρηση επισκεψιμότητας και προβολή διαφημίσεων.
        </p>

        <h2>1. Κατηγορίες cookies</h2>
        <ul>
          <li>Απαραίτητα: απαιτούνται για βασικές λειτουργίες του site.</li>
          <li>Analytics (προαιρετικά): βοηθούν να κατανοούμε πώς χρησιμοποιείται η πλατφόρμα.</li>
          <li>Διαφημιστικά (προαιρετικά): επιτρέπουν φόρτωση Google AdSense.</li>
        </ul>

        <h2>2. Ποια εργαλεία χρησιμοποιούμε</h2>
        <ul>
          <li>PostHog (analytics) για στατιστική βελτίωση υπηρεσίας.</li>
          <li>Google AdSense (διαφημίσεις), μόνο αν το επιλέξετε.</li>
          <li>Google Consent Mode για εφαρμογή ρυθμίσεων συγκατάθεσης.</li>
        </ul>

        <h2>3. Πώς δίνετε ή ανακαλείτε συγκατάθεση</h2>
        <p>
          Για διαφημίσεις Google εφαρμόζονται μηνύματα συγκατάθεσης μέσω της πλατφόρμας διαχείρισης
          συγκατάθεσης (Google CMP) όπου αυτό απαιτείται. Από εκεί μπορείτε να αποδεχτείτε, να απορρίψετε
          ή να διαχειριστείτε επιλογές.
        </p>
        <p>
          Για εξατομικευμένες ρυθμίσεις διαφημίσεων Google μπορείτε επίσης να επισκεφθείτε το
          {' '}<a href="https://myadcenter.google.com/" target="_blank" rel="noopener noreferrer" className="underline">My Ad Center</a>.
        </p>

        <h2>4. Διαχείριση από browser</h2>
        <p>
          Μπορείτε επίσης να διαγράψετε ή να μπλοκάρετε cookies από τις ρυθμίσεις του browser σας. Αυτό μπορεί
          να επηρεάσει τη λειτουργία τμημάτων του site.
        </p>
      </LegalLayout>
    </>
  )
}

export default Cookies
